import { useMemo } from "react";
import { useSyncExternalStore } from "react";
import { getCurrentLocale, subscribe, translate } from "../utlis/locale";

/**
 * Reactive translation hook.
 *
 *   const t = useT("popup");
 *   t("logout_confirmation")            // -> localized string
 *   t("welcome", { name: "Aki" })       // -> "{name}" interpolated
 *
 * Re-renders on locale change. Missing keys fall back to English, then to the
 * key path in dev (with a console.warn) or "" in production.
 *
 * @param {string} [section] Optional bundle section to scope keys against.
 */
const useT = (section) => {
  // Subscribe so consumers re-render when the language changes.
  const locale = useSyncExternalStore(subscribe, getCurrentLocale);

  return useMemo(
    () => (key, vars) => translate(section, key, vars),
    // `locale` is intentionally in deps so `t` is a fresh fn per language.
    [section, locale],
  );
};

export { useT };
export default useT;
